import { Box, styled, Paper as MuiPaper } from '@mui/material';
import React, { FC, useState } from 'react';

import { Typography } from '..';

import EditModeCard from './EditModeCard';
import ViewModeCard from './ViewModeCard';

export interface UserData {
  name?: string;
  email?: string;
  createdAt?: string;
  phoneNumber?: string;
}

export interface ProfileCardProps {
  user: UserData;
  handleUpdateData: (data: {
    name?: string;
    email?: string;
    phone_number?: string;
  }) => Promise<void>;
  editable?: boolean;
}

const Paper = styled(MuiPaper)(({ theme }) => ({
  padding: '16px 41px',
  border: 'none',
  boxShadow: theme.shadows[2],
  minWidth: '500px',
  marginBottom: theme.spacing(3),
}));

const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingBottom: theme.spacing(2),
}));

const ProfileCard: FC<ProfileCardProps> = ({
  user,
  handleUpdateData,
  editable = false,
}) => {
  const [editMode, setEditMode] = useState(false);

  return (
    <Paper data-testid="PROFILE_CARD">
      <Header>
        <Typography variant="h5" data-testid="PROFILE_CARD_NAME">
          {user?.name}
        </Typography>
      </Header>
      {editable && editMode ? (
        <EditModeCard
          user={user}
          handleEditMode={setEditMode}
          handleUpdateData={handleUpdateData}
        />
      ) : (
        <ViewModeCard
          user={user}
          handleEditMode={setEditMode}
          editable={editable}
        />
      )}
    </Paper>
  );
};

export default ProfileCard;
